import React, { useState, useEffect, useRef } from "react";
import { styled } from "@mui/material/styles";
import { makeStyles, Button, Grid } from "@material-ui/core";
import Typography from "@mui/material/Typography";
import {  Form, Select, Input, message } from 'antd';
const { Option } = Select;
import { 
  fileTypes,
  emailPushSettingDetail,
  saveEmailPushSetting
 } from "../../actions/subscribe";

import closeSvg from "../../assets/svg/delete.svg";

const useStyles = makeStyles({
  box: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: (width) => {
      return width + "px";
    },
    background: "#fff",
    boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.2)",
    borderRadius: "4px",
  },
  title: {
    width: "100%",
    height: "48px",
    padding: "0 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #e9e9e9",
    fontSize: "14px !important",
    color: "#666",
    boxSizing: "border-box",
    "& img": {
      cursor: "pointer",
    },
  },
  content: {
    width: "100%",
    padding: "18px 30px 18px 30px",
    boxSizing: "border-box",
  },
  inputGroup: {
    position: "relative",
    display: "flex",
  },
  searchList: {
    position: "absolute",
    top: "42px",
    background: "#fff",
    minWidth: "300px",
    maxHeight: "300px",
    overflow: "auto",
    boxSizing: "border-box",
    border: "1px solid #d9d9d9",
    "& p": {
      height: "40px",
      lineHeight: "40px",
      padding: "0 10px",
      cursor: "pointer",
      "&:hover": {
        background: "#f1f1f1",
      },
    },
  },
  input: {
    width: "300px",
    height: "40px",
    padding: "0 15px",
    border: "1px solid #d9d9d9",
    fontSize: "16px",
    color: "#000",
    boxSizing: "border-box",
    borderRadius: "2px",
    outline: "none",
    "&::-webkit-input-placeholder": {
      color: "rgba(0, 0, 0, .25)",
    },
  },
  footer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    height: "78px",
    padding: "0 27px",
    borderTop: "1px solid #e9e9e9",
  },
  btn: {
    width: "90px",
    height: "40px",
    borderRadius: "2px",
    background: "#0F25D1  !important",
    color: "#fff",
    fontSize: "14px",
    boxShadow: "none !important",
  },
  grayBtn: {
    width: "90px",
    height: "40px",
    marginLeft: "20px",
    borderRadius: "2px",
    border: "1px solid #d9d9d9",
    background: "#fff !important",
    color: "#0F25D1",
    fontSize: "14px",
    boxShadow: "none !important",
  },
  formItem: {
    width: "100%",
    marginBottom: "24px !important",
    display: "flex",
    alignItems: "center",
    flexFlow: "row",
    flexDirection: "row !important",
    "& label": {
      width: "80px",
      textAlign: "right",
    },
    '& .ant-select': {
      width: '100%',
      flex: 1
    },
    '& .ant-input': {
      width: '100%',
      flex: 1
    }
  },
});
export default function SettingModal(props) {
  const { userEmail, close, save, width, title } = props;
  const [form] = Form.useForm();
  const classes = useStyles(width);
  const [isInit, setIsInit] = useState(false);
  const [email, setEmail] = useState('');
  const [fileType, setFileType] = useState([]);
  const [fileTypeList, setFileTypeList] = useState([]);
  const [settingInfo, setSettingInfo] = useState([]);
  useEffect(() => {
    if (isInit && fileTypeList.length > 0) {
      setDefault()
    }
    if (fileTypeList.length == 0 && settingInfo.length == 0) {
      queryParams()
      querySettingInfo()
    }
  }, [isInit, fileTypeList, settingInfo]);

  // 查询邮件推送-文件类型
  const queryParams = () => {
    fileTypes().then(res => {
      if (res && res instanceof Array) {
        let data = res.filter(v => {
          return v.category_name
        })
        setFileTypeList(data)
      }
    })
  }

  const querySettingInfo = () => {
    emailPushSettingDetail().then(res => {
      if (res && res.length > 0 && res instanceof Array) {
        setSettingInfo(res)
        let email = res[0].email_receive_push
        let ids = res.map(v => {
          return v.file_category.id
        })
        setEmail(email)
        setFileType(ids)
        form.setFieldsValue({ email: email, fileType: ids });
      } else {
        setIsInit(true)
      }
    })
  }
  
  const setDefault = () => {
    let ids = fileTypeList.map(v => {
      return v.id
    })
    setEmail(userEmail)
    setFileType(ids)
    form.setFieldsValue({ email: userEmail, fileType: ids });
  }

  const submit = () => {
    if (!email || fileType.length == 0) {
      return
    }
    let form = new FormData()
    form.append('email_receive_push', email)
    form.append('category_ids', fileType.join('|'))
    saveEmailPushSetting(form).then(res => {
      if (res.message == 'Relationships created successfully') {
        save()
        message.success('设置成功')
      } else {
        message.error(res.message)
      }
    })
  }


  return (
    <div className={classes.box}>
      <Typography className={classes.title}>
        <Typography variant="span">{title}</Typography>
        <Typography variant="span" onClick={() => close()}>
          <img src={closeSvg} />
        </Typography>
      </Typography>

      <div className={classes.content}>
        <Form
          name="basic"
          form={form}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          initialValues={{ remember: true }}
          autoComplete="off"
        >
          <Form.Item
            label="文件类型"
            name="fileType"
            rules={[{ required: true, message: '请选择文件类型' }]}
            >
            <Select
              className={classes.select}
              placeholder="请选择文件类型"
              value={fileType}
              mode="multiple"
              onChange={e => setFileType(e)}
            >
              {
                fileTypeList.map(v => {
                  return (
                    <Option value={v.id} key={v.id}>{v.category_name}</Option>
                  )
                })
              }
            </Select>
          </Form.Item>
          <Form.Item
            label="邮箱地址"
            name="email"
            rules={[{ required: true, message: '请输入邮箱地址' }]}
            >
            <Input 
              value={email}
              onChange={e => setEmail(e.target.value ? e.target.value : '')} 
              placeholder={`请输入邮箱地址`}/>
          </Form.Item>
        </Form>
      </div>
      <div className={classes.footer}>
        <Button className={classes.btn} variant="contained" onClick={submit}>
          保存
        </Button>
        <Button onClick={close} className={classes.grayBtn} variant="contained">
          取消
        </Button>
      </div>

    </div>
  );
}
